import React from "react";
import { NewsFeed } from "./../features/news-feed";

import { ROUTES } from "../shared/constants/routes";
import AppLoader from "../components/AppLoader";
import { useTranslation } from "react-i18next";
import { useActiveTabStore } from "../store/activeTabStore";
import { View } from "react-native";
import WatchScreen from "../features/watch";

export const HomeScreen = () => {
  const activetab = useActiveTabStore((state) => state.activetab);
  const { t } = useTranslation();
  switch (activetab.toLowerCase()) {
    case ROUTES.READ:
    case ROUTES.LISTEN:
      return <NewsFeed fromRadio={activetab.toLowerCase() === ROUTES.LISTEN} />;
    case ROUTES.WATCH:
      return <WatchScreen/>
  }
};